<script setup lang="ts">
import MateMailEvent from "./events/MateMailEvent.vue";
import StrollEvent from "./events/StrollEvent.vue";
import MateInvitationEvent from "./events/MateInvitationEvent.vue";
import { InteractionEventType } from "@/enums/mission";
import { InteractionEvent } from "@/types/entity";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    event: InteractionEvent;
    isNeedAction?: boolean;
  }>(),
  {
    isNeedAction: false,
  }
);

const emit = defineEmits<{
  (e: "edit-mail", interactionEvent: InteractionEvent): void;
}>();

/**
 * 需要审批的事件
 * 1. 出门溜达
 * 2. 写信
 * 3. 好友邀请
 * 4. 收到好友邀请
 */
const requestText = computed<{
  title: string;
  desc: string;
  icon: string;
}>(() => {
  switch (props.event.type) {
    // 1
    case InteractionEventType.JoinedInteractionPool:
      return {
        title: "进入了互动池",
        desc: "互动模式开启",
        icon: "iconify mingcute--group-3-fill",
      };
    // 2
    case InteractionEventType.LeftInteractionPool:
      return {
        title: "离开了互动池",
        desc: "互动模式关闭",
        icon: "iconify mingcute--group-3-fill",
      };
    case InteractionEventType.BlockedMate:
      return {
        title: "拉黑",
        desc: "拉黑",
        icon: "iconify ic--outline-block",
      };
    // 10
    case InteractionEventType.UnblockedMate:
      return {
        title: "取消拉黑",
        desc: "取消拉黑",
        icon: "iconify ic--outline-block",
      };
    case InteractionEventType.MissionInvitationSent:
      return {
        title: "任务邀请发送",
        desc: "任务邀请发送",
        icon: "iconify mingcute--flag-1-fill",
      };
    // 11
    // case InteractionEventType.DispatchedMission:
    //   return {
    //     title: "执行任务",
    //     desc: "执行任务",
    //     icon: "iconify mingcute--flag-1-fill",
    //   };
    default:
      return {
        title: "未知",
        desc: "未知",
        icon: "iconify mdi-help-circle",
      };
  }
});
</script>

<template>
  <div
    class="p-2 text-primary-content shadow-md rounded font-[Cubic] flex flex-col gap-2"
    :class="{
      'bg-primary/60': isNeedAction,
    }"
  >
    <MateMailEvent
      v-if="
        event.type === InteractionEventType.RequestLetterSending ||
        event.type === InteractionEventType.LetterSent ||
        event.type === InteractionEventType.ReceivedLetter
      "
      :event="event"
      :is-need-action="isNeedAction"
      @edit-mail="emit('edit-mail', $event)"
    />
    <StrollEvent
      v-else-if="
        event.type === InteractionEventType.RequestStroll ||
        event.type === InteractionEventType.StrollDispatched ||
        event.type === InteractionEventType.StrollReturned
      "
      :event="event"
      :is-need-action="isNeedAction"
    />
    <MateInvitationEvent
      v-else-if="
        event.type === InteractionEventType.FriendInvitationSent ||
        event.type === InteractionEventType.ReceivedLetterFriendInvitation ||
        event.type === InteractionEventType.FriendInvitationApproved ||
        event.type === InteractionEventType.FriendInvitationRejected
      "
      :event="event"
      :is-need-action="isNeedAction"
    />
    <MateDispatchEvent
      v-else-if="
        event.type === InteractionEventType.MissionInvitationApproved ||
        event.type === InteractionEventType.MissionInvitationRejected ||
        event.type === InteractionEventType.MissionReturned ||
        event.type === InteractionEventType.ReceivedMissionInvitation ||
        event.type === InteractionEventType.DispatchedMission ||
        event.type === InteractionEventType.RequestMission
      "
      :event="event"
      :is-need-action="isNeedAction"
    />
    <MomentEvent
      v-else-if="
        event.type === InteractionEventType.RequestMomentPost ||
        event.type === InteractionEventType.RequestMomentComment
      "
      :event="event"
      :is-need-action="isNeedAction"
    />
    <template v-else>
      <InteractionItemHeader
        :mate="event.mate!"
        :title="event.title"
        :desc="requestText.desc"
        :icon="requestText.icon"
        :dtCreate="event.dtCreate"
        :is-need-action="isNeedAction"
      />
      <div
        :class="{
          'text-primary-content': isNeedAction,
          'text-base-content': !isNeedAction,
        }"
      >
        {{ event.content }}
      </div>
    </template>
  </div>
</template>
